module.exports = __webpack_public_path__ + "img/DeliveredStage.da809d09.svg";